export function FilterSelect(props: {
  label: string;
  value: string | undefined;
  options: { value: string; label: string }[];
  onChange: (v: string | undefined) => void;
}) {
  return (
    <select
      className="chip"
      aria-label={props.label}
      value={props.value ?? ''}
      onChange={(e) => props.onChange(e.target.value || undefined)}
    >
      <option value="">{props.label}</option>
      {props.options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  );
}
